import React, { useState, useEffect } from "react";
import Modal from "@material-ui/core/Modal";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { useSnackbar } from "notistack";
import apiform from "utils/APIForm";
import api from "utils/API";
import TableExamData from "views/Widgets/FichaPaciente/Examenes/TableExamData";
import TableExamProf from "views/Widgets/FichaPaciente/Examenes/TableExamProf";
import DocumentosAdjuntosTarea from "components/ClinicalRequests/DocumentosAdjuntosTarea";
import moment from "moment-timezone";
import "moment/locale/es";
moment.locale("es");

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2)
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  }
});

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  paper: {
    position: "absolute",
    width: "60%",
    height: "80%",

    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)"
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120
  },
  table: {
    minWidth: 650
  },
}));

const ModalTitle = withStyles(styles)(props => {
  const { children, classes, onClose, ...other } = props;

  return (
    <MuiDialogTitle
      disableTypography
      className={classes.root}
      {...other}
      style={{ textAlign: "center" }}
    >
      <Typography variant="h6" style={{ textTransform: "none" }}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2)
  }
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(1)
  }
}))(MuiDialogActions);

const dictDocument = {
  orden: {
    title: `Orden para "Tratamiento Antibiótico"`,
    attachLabel: "Adjuntar orden",
    uploadLabel: "Subir orden",
    tipoDocumento: "OrdenTratamientoAntibiotico",
    flow: "antibiotico",
    urlSubir: tempRow => `/api/paciente/${tempRow.id_solicitud_paciente.id_paciente_id}/solicitudes/tratamiento/antibiotico/${tempRow.id_solicitud_paciente.id}/documentos/orden_tratamiento_antibiotico/subir/`,
    errorMessage: "No se pudo subir la orden. Intente nuevamente.",
    successMessage: "Orden de tratamiento antibiótico subida",
  },
  autorizacion: {
    title: `Autorización Isapre para "Tratamiento Antibiótico"`,
    attachLabel: "Adjuntar autorización isapre",
    uploadLabel: "Subir autorización",
    tipoDocumento: "AutorizacionTratamientoAntibioticoIsapre",
    flow: "antibiotico",
    urlSubir: tempRow => `/api/paciente/${tempRow.id_solicitud_paciente.id_paciente_id}/solicitudes/tratamiento/antibiotico/${tempRow.id_solicitud_paciente.id}/documentos/autorizacion_tratamiento_antibiotico/subir/`,
    errorMessage: "No se pudo subir la autorización. Intente nuevamente.",
    successMessage: "Autorización isapre subida",
  },
  ordenPersonalClinico: {
    title: `Orden médica para "Personal Clínico"`,
    attachLabel: "Adjuntar orden",
    uploadLabel: "Subir orden",
    tipoDocumento: "OrdenPersonalClinico",
    flow: "personalClinico",
    urlSubir: tempRow => `/api/paciente/${tempRow.id_solicitud_paciente.id_paciente_id}/solicitudes/profesionaleextras/${tempRow.id_solicitud_paciente.id}/documentos/OrdenPersonalClinico/subir/`,
    errorMessage: "No se pudo subir la orden. Intente nuevamente.",
    successMessage: "Orden de personal clínico subida",
  },
};

const allowedExtensions = ["pdf", "jpg", "jpeg", "png"];

const ModalUploadDocumentAntibiotic = props => {
  const classes = useStyles();
  const { openModal, closeModal, tempRow, documentType, setinitialCharge } = props;
  const infoDocument = dictDocument[documentType];
  const [firstCharge, setFirstCharge] = useState(true);
  const [fileDocument, setFileDocument] = useState(null);

  const [indications, setIndications] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [priority, setPriority] = useState("");
  const [supplies, setSupplies] = useState([]);
  const [listProfesional, setlistProfesional] = useState([]);
  const [sending, setSending] = useState(false);

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const action = key => (
    <Button style={{background: "#af4c4c00",  color: "#fff"}} onClick={() => {closeSnackbar(key)}}>
        CERRAR
    </Button>
  );

  const handleSnakeMessage = (message, variant) => {
    enqueueSnackbar(message, {
      variant,
      action,
      preventDuplicate: true,
      anchorOrigin: { vertical: "top", horizontal: "center" },
    });
  };

  useEffect(() => {
    if (firstCharge) {
      initialCharge();
    }
  });

  const initialCharge = () => {
    setFirstCharge(false);
    if (infoDocument.flow !== "antibiotico") {
      return;
    }
    const getRequestAntibiotic = api.get(
      `/api/paciente/${tempRow.id_solicitud_paciente.id_paciente_id}/solicitudes/tratamiento/antibiotico/${tempRow.id_solicitud_paciente.id}/`
    );
    Promise.all([getRequestAntibiotic]).then(response => {
        const dataAntibiotic = response[0].data.tratamiento_antibiotico || {};
        setStartDate(dataAntibiotic.fecha_agendada || null);
        setEndDate(dataAntibiotic.fecha_termino || null);
        setPriority(tempRow.id_solicitud_paciente.prioridad);
        setIndications(dataAntibiotic.indicaciones);

        let tempSupplies = [];
        response[0].data.lista_insumos.map(row => {
          if (row.id_insumo_medicamento__grupo_producto === "Medicamentos") {
            tempSupplies.push({
              id: row.id_insumo_medicamento_id,
              item: row.id_insumo_medicamento__descripcion_producto,
              sku: row.id_insumo_medicamento__SKU,
              cantidad: row.cantidad_necesaria,
              tipo: row.id_insumo_medicamento__grupo_producto
            });
          }
        });
        response[0].data.lista_insumos.map(row => {
          if (row.id_insumo_medicamento__grupo_producto === "Insumos") {
            tempSupplies.push({
              id: row.id_insumo_medicamento_id,
              item: row.id_insumo_medicamento__descripcion_producto,
              sku: row.id_insumo_medicamento__SKU,
              cantidad: row.cantidad_necesaria,
              tipo: row.id_insumo_medicamento__grupo_producto
            });
          }
        });
        setlistProfesional(response[0].data.lista_cargos.reduce(
          (accum, obj) => ([
            ...accum,
            {
              cantidad: obj.cantidad_necesaria,
              nombre: obj.id_cargo__nombre_corto,
            },
          ]),
          []
        ))
        setSupplies(tempSupplies);
      }).catch(() => {
        handleSnakeMessage("No se pudo cargar la información de la solicitud", "error");
      })
  };

  const handleSelectFile = (files) => {
    if (!files || files.length === 0) {
      return;
    }
    const extension = files[0].name.split(".").pop().toLowerCase();
    if (!allowedExtensions.includes(extension)) {
      handleSnakeMessage(`Tipo de archivo no permitido. Formatos aceptados: ${allowedExtensions.join(", ")}`, "warning");
      return;
    }
    setFileDocument(files);
  };

  const saveDocument = () => {
    if (sending) {
      return;
    }
    setSending(true);
    const formData = new FormData();
    formData.append("archivo", fileDocument[0]);
    formData.append("tipo_documento", infoDocument.tipoDocumento);
    formData.append("nombre_archivo", fileDocument[0].name);
    formData.append("id_paciente", tempRow.id_solicitud_paciente.id_paciente_id);
    apiform
      .post(infoDocument.urlSubir(tempRow), formData)
      .then(responseFile => {
        handleSnakeMessage(infoDocument.successMessage, "success");
        if (setinitialCharge) {
          setinitialCharge(true);
          closeModal();
        } else {
          window.location.reload();
        }
      }).catch(() => {
        handleSnakeMessage(infoDocument.errorMessage, "error");
        setSending(false);
      })
  };

  return (
    <Modal
      open={openModal}
      onClose={closeModal}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      disableBackdropClick
    >
      <Paper
        className={classes.paper}
        style={{ height: "90%", overflow: "auto" }}
      >
        <ModalTitle id="customized-dialog-title">
          {infoDocument.title}
        </ModalTitle>

        <DialogContent>
          <Grid
            item
            container
            xs={12}
            justify="center"
          >
            {infoDocument.flow === "antibiotico" && (
              <>
                <Grid container className={classes.root} justify="center">
                  <Grid item container xs={12} direction="column" justify="center" alignContent="center" spacing={1}>
                      <Typography variant="body2" gutterBottom>
                        Fecha inicio tratamiento:
                        <span style={{ fontWeight: "bold" }}>
                          {startDate ? moment(startDate).format("YYYY-MM-DD") : "-"}
                        </span>
                      </Typography>
                      <Typography variant="body2" gutterBottom>
                        Fecha término tratamiento:
                        <span style={{ fontWeight: "bold" }}>
                          {endDate ? moment(endDate).format("YYYY-MM-DD") : "-"}
                        </span>
                      </Typography>
                      <Typography variant="body2" gutterBottom>
                        Prioridad:
                        <span style={{ fontWeight: "bold" }}>{priority}</span>
                      </Typography>
                      <Typography variant="body2" gutterBottom>
                        Indicaciones:
                        <span style={{ fontWeight: "bold" }}>{indications}</span>
                      </Typography>

                  </Grid>
                </Grid>
                <Grid item container xs={12} justify="center">
                  <TableExamData supplies={supplies} />
                </Grid>
                <Grid item container xs={12} justify="center">
                  <TableExamProf supplies={listProfesional} />
                </Grid>
              </>
            )}
            <Grid
              item
              container
              xs={6}
              style={{ margin: "10px 0" }}
              justify="center"
            >
              <Grid
                item
                container
                xs={12}
                justify="center"
                style={{ marginBottom: "4px" }}
              >
                {fileDocument != null
                  ? fileDocument[0].name
                  : null}
              </Grid>
              <input
                id="contained-button-file"
                type="file"
                accept={allowedExtensions.map((ext) => `.${ext}`).join(",")}
                onChange={e => handleSelectFile(e.target.files)}
                hidden
              />
              <label htmlFor="contained-button-file">
                <Button
                  variant="contained"
                  color="primary"
                  component="span"
                  style={{ textTransform: "none", marginRight: "3px" }}
                >
                  {infoDocument.attachLabel}
                </Button>
              </label>
            </Grid>
            <DocumentosAdjuntosTarea idTarea={tempRow.id} />
          </Grid>
        </DialogContent>
        <DialogActions
          style={{ justifyContent: "center", marginBottom: "1em" }}
        >
          <Button
            disabled={fileDocument == null || sending}
            variant="contained"
            style={fileDocument == null || sending ? { textTransform: "none" } : {
              backgroundColor: "#43a047",
              textTransform: "none",
              color: "#fff"
            }}
            onClick={saveDocument}
          >
            {sending ? "Subiendo..." : infoDocument.uploadLabel}
          </Button>
          <Button
            variant="contained"
            color="primary"
            style={{
              textTransform: "none"
            }}
            onClick={closeModal}
          >
            Atrás
          </Button>
        </DialogActions>
      </Paper>
    </Modal>
  );
};

export default ModalUploadDocumentAntibiotic;

ModalUploadDocumentAntibiotic.propTypes = {
  openModal: PropTypes.bool,
  closeModal: PropTypes.func,
  tempRow: PropTypes.object,
  documentType: PropTypes.oneOf(["orden", "autorizacion", "ordenPersonalClinico"]),
  setinitialCharge: PropTypes.func
};
